import React from 'react';
import Box from '@mui/material/Box';

import { StripeCardNumberInput, StripeCardExpireInput, StripeCardCvcInput } from '../..';

export const VpStripeInputs = () => {
  return (
    <>
      <StripeCardNumberInput />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '20px'
        }}
      >
        <StripeCardExpireInput />
        <StripeCardCvcInput />
      </Box>
    </>
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/Stripe/VpStripeInputs.jsx